import {integrationCmdService, resourceCmdService, resourceQueryService, zapierService} from '../index'
import INTEGRATION_TYPES from './../../data/integrationTypes.json'
class Integration {
    addIntegration = (teamId, data) => integrationCmdService.post(`team/${teamId}/integration/`, data)
    deleteIntegration = async(teamId, providerId, type) => {
        const {data} = type === INTEGRATION_TYPES.types.zapier ?
            await zapierService.delete(`team/${teamId}/integration/${providerId}`) :
            await integrationCmdService.delete(`team/${teamId}/integration/${providerId}`)
        return data
    }
    getIntegrations = async(teamId, withZapier = true) => {
        const integrationsResponse = await integrationCmdService.get(`team/${teamId}/integrations`)
        const integrations = integrationsResponse?.data?.data?.integrations || []
        const zapierResponse = withZapier && await zapierService.get(`team/${teamId}/integrations`)
        const zapierIntegrations = zapierResponse?.data?.data?.integrations?.map(item => ({
            ...item,
            type: 'zapier',
            name: 'Zapier',
            provider_id: item.integration_id
        })) || []
        return [...integrations, ...zapierIntegrations]
    }
    updateIntegraitonStatus = (teamId, integrationId, data, withZapier) => {
        if (withZapier) {
            return zapierService.put(`team/${teamId}/integration/${integrationId}/status`, data)
        }
        return integrationCmdService.put(`team/${teamId}/integration/${integrationId}/status`, data)
    }
    editIntegration = (teamId, providerId, data) => integrationCmdService.patch(`team/${teamId}/integration/${providerId}`, data)
    getComponents = (teamId, providerId) => integrationCmdService.get(`team/${teamId}/integration/${providerId}`)
    addResourceIntegration = (resourceId, data) => resourceCmdService.post(`resource/${resourceId}/integration`, data)
    updateResourceIntegration = (resourceId, integration, data) => resourceCmdService.put(`resource/${resourceId}/integration/${integration}`, data)
    deleteResourceIntegration = (resourceId, integration) => resourceCmdService.delete(`resource/${resourceId}/integration/${integration}`)
    getResourceIntegration = (resourceId) => resourceQueryService.get(`resource/${resourceId}/integrations`)
    addZapierIntegration = (data) => zapierService.post('oauth/authorize', data)
}

export default new Integration()
